// react
import React, { useEffect, useContext} from 'react';
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import moment from "moment";
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import Select from 'react-select';
import {ValidSelect} from "beaktShared/helpers/validselect";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

// services
import { MaskMonthYear, transformValueFloattoFormated, formateDate  } from "beaktShared/helpers/masks";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function RelatorioLogFechamento() {
    const { t } = useTranslation();

    const session = useContext(SessionContext);
    const { register, setValue, errors, setError, clearError, getValues } = useForm({mode: "onBlur"});
   
    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => {
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };
    
    useEffect(() => {
        let mesano = moment(new Date()).add(-1, 'months').format('MM/YYYY');
        setValue('mesano', mesano); 

        LoadEstabelecimentos();

    }, []);      

    const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [estabelecimento, setestabelecimento] = React.useState(0);
    const LoadEstabelecimentos = () => {
        setisLoadingEstabelecimento(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/"+session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
        if (result.status !== 200) {
            showNotification(result.message, 'error')
            setisLoadingEstabelecimento(false);
            return false;
        }

        setisLoadingEstabelecimento(false);
        setestabelecimentos(result.data);
        return true;
        });
    };
    const handleEstabelecimentoChange = event => {
        let value = event
        setestabelecimento(value);
        setValue("estabelecimento", value);
        if (value !== "")
            clearError("estabelecimento");
    };
    
    const handleClickPesquisa = () =>{
        let data = getValues();
        
        if (estabelecimento === 0)
            return setError("estabelecimento", "required")
        else
            clearError("estabelecimento")

        if(data.mesano === "")
        {
            setError("mesano","required", t('label.required'))
            return false;
        }
        else
            clearError("mesano")
        
        if (!moment(data.mesano, 'MM/YYYY',true).isValid()) {
            setError("mesano", "invaliddate",  t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("mesano")

        let obj = {
            estabelecimentoId: estabelecimento,
            mesAno:data.mesano
        }
        loadDados(obj);
    };

    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [list, setlist] = React.useState([]);
    const loadDados = (obj) =>{
        setisLoadingList(true);       
        const endPoint = "royalties/log/" + obj.estabelecimentoId + "/" + obj.mesAno.replace("/", "-");
        UseGetApiSimple(endPoint,obj).then(result=>{    
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                setisLoadingList(false);
                return false; 
            }                
            setlist(result.data);
            loadDataCsv(result.data);
            setisLoadingList(false);   
            return true;                
        });  
    }

    const columnsProp = [
        {
            Header: t('label.date'),
            filterable: false,
            accessor: "dataLog",
            Cell: (props) => <div> {props.value?formateDate(props.value):""} </div> 
        },
        {
            Header: t('label.user'),
            filterable: false,
            accessor: "usuarioNome",
        },
        {
            Header: t('label.value_royalties'),
            filterable: false,
            accessor: "valorRoyalties",
            Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div> 
        },
        {
            Header: t('label.value_total'),
            filterable: false,
            accessor: "valorFinal",
            Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div> 
        }
    ]

    const columns = [...columnsProp]

    const [dataCSV,setdataCSV] = React.useState([]);  
    const columnsCSV = [
        {id: 'dataLog', displayName: 'Data'}, 
        {id: 'usuarioNome', displayName: 'Usuário'}, 
        {id: 'valorRoyalties', displayName: 'Valor Royalties'}, 
        {id: 'valorFinal', displayName: 'Valor Final'}        
    ];
    const loadDataCsv = (data) =>{        
        setdataCSV(data);
    } 

    const classes = useStyles();
    return (
        <div>
            <GridContainer>
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('reports.closing_log_report')}</h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer>                                
                                <GridItem xs={12} sm={12} md={6}>
                                    <FormControl fullWidth className={classes.formControl}>
                                        <label className={errors.estabelecimento ? "select__label select__label_error" : "select__label"}>
                                            {t('label.establishment')} *</label>
                                        <Select
                                            classNamePrefix="select"
                                            styles={ValidSelect(errors.estabelecimento ? true : false)}
                                            isSearchable={true}
                                            isLoading={isLoadingEstabelecimento}
                                            name="estabelecimento"
                                            placeholder={t('label.select')+"..."}
                                            options={estabelecimentos}
                                            value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento)}
                                            getOptionLabel={({ descricao }) => descricao}
                                            getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                            onChange={(value) => handleEstabelecimentoChange(value.estabelecimentoId !== null ? value.estabelecimentoId : "")}
                                            ref={() => register({ name: "estabelecimento" })
                                            }
                                        />
                                        {errors.estabelecimento &&
                                        <FormHelperText>
                                            <span className="obg"> {t('label.required')} </span>
                                        </FormHelperText>}
                                    </FormControl>                                            
                                </GridItem>
                                <GridItem xs={12} sm={4} md={3}>
                                    <FormControl fullWidth className={classes.formControl}>   
                                    <TextField          
                                        variant="outlined"   
                                        InputLabelProps={{shrink: true}}                  
                                        label={t('label.month_year')+" *"}                                                         
                                        name="mesano"        
                                        inputRef={register({required: t('label.required')})}  
                                        error={errors.mesano?true:false}  
                                        defaultValue={''}                                       
                                        InputProps={{ inputComponent: MaskMonthYear }}   
                                    />
                                    {errors.mesano &&<FormHelperText className={classes.labelRootError}>
                                        <span> {errors.mesano.message} </span>
                                    </FormHelperText> }  
                                    </FormControl>  
                                </GridItem> 
                                <GridItem xs={12} sm={6} md={2}>
                                <Button  round color="primary" 
                                    onClick={e => { handleClickPesquisa()}}>
                                    {t('button.search')} 
                                </Button>
                                </GridItem>
                                
                                {notification.show &&
                                <div><br/>
                                <SnackbarContent
                                    message={notification.message}
                                    color={notification.color}
                                    closeNotification={() => setNotification({show:false})}
                                    close
                                /></div>}
                            </GridContainer>   

                            
                            {dataCSV.length > 0 &&
                                <div>
                                    <div style={{float:'right'}}>
                                    <CsvDownloader
                                    filename="report"
                                    columns={columnsCSV}
                                    datas={dataCSV}
                                    separator={";"}>
                                        <Button  round color="default" size="sm" >CSV</Button> 
                                    </CsvDownloader>
                                    </div><div style={{clear:'both'}}></div>
                                </div>
                            }
                            
                            <div>
                            <ReactTable
                                loading = {isLoadingList}
                                data={list}
                                filterable
                                defaultFilterMethod = {noCaseSensitive}
                                columns={columns}
                                minRows={5}
                                //defaultPageSize={10}
                                showPagination={false}
                                pageSize={list.length}
                                className="-striped -highlight"
                                previousText={t('button.previous')}
                                nextText={t('button.next')}
                                loadingText={t('label.loading')+"..."}
                                noDataText={t('information_message.no_records_found')+"!"}
                                pageText={t('label.page')}
                                ofText={t('label.of')}
                                rowsText={t('label.rows')}
                            />
                            </div>                            
                        </CardBody>
                    </Card>
                </GridItem>            
            </GridContainer>
        </div>
    );
}
